import BaseController from "../../controller/BaseController";
import AdminDataService from "../../util/AdminDataService";
import JSONModel from "sap/ui/model/json/JSONModel";
import { Button$PressEvent } from "sap/m/Button";
import { Dialog$AfterCloseEvent } from "sap/m/Dialog";
import SelectDialog from "sap/m/SelectDialog";
import StandardListItem from "sap/m/StandardListItem";
import DataService from "../../util/DataService";
import Validator from "../../util/Validator";
import Filter from "sap/ui/model/Filter";
import FilterOperator from "sap/ui/model/FilterOperator";

/**
 * @namespace com.reply.leaviosa.controller
 */
export default class TeamsController extends BaseController {
    private readonly DIALOG_ID = "DialogCreateUpdateTeam";
    private _oSelectDialog: SelectDialog;

    public async onInit(): Promise<void> {
        AdminDataService.getTeams();
        DataService.getUsers();
    }

    //*************************************************************************************
    // EVENT HANDLERS
    //*************************************************************************************

    public async onCreateTeam(): Promise<void> {
        this.getView().setModel(new JSONModel({
            "edit": false
        }), "team");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onEdit(oEvent: Button$PressEvent): Promise<void> {
        const selectedTeam = oEvent.getSource().getBindingContext("dataModel").getObject();
        const team = {
            "edit": true,
            ...selectedTeam
        }
        this.getView().setModel(new JSONModel(team), "team");
        await this.openDialog(this.DIALOG_ID);
    }

    public async onSaveDialog(oEvent: Dialog$AfterCloseEvent): Promise<void> {

        const validator = new Validator();
        const valid = validator.validate(oEvent.getSource().getParent());
        if (!valid) return;

        const teamData = (this.getView().getModel("team") as JSONModel).getData();

        if (teamData.id) {
            await AdminDataService.updateTeam(teamData);
        } else {
            await AdminDataService.createTeam(teamData);
        }
        AdminDataService.getTeams();

        this.destroyDialog(this.DIALOG_ID);
    }

    onCloseDialog(oEvent: Dialog$AfterCloseEvent): void {
        AdminDataService.getTeams();
        this.destroyDialog(this.DIALOG_ID);
    }

    onNavigateTeam(oEvent: Button$PressEvent): void {
        const currentTeam = oEvent.getSource().getBindingContext("dataModel").getObject() as any;
        this.navTo("team", {
            id: currentTeam.id
        });
    }

    async onAddTeamLead(oEvent: Button$PressEvent): Promise<void> {

        AdminDataService.getUsersInGroup("TEAMLEADS");

        if (!this._oSelectDialog) {
            this._oSelectDialog = new SelectDialog({
                title: "Select Team Lead",
                multiSelect: false,
                items: {
                    path: "dataModel>/TEAMLEADS",
                    template: new StandardListItem({
                        title: "{dataModel>firstName} {dataModel>lastName}",
                        description: "{dataModel>email}"
                    })
                },
                confirm: this.onTeamLeadSelected.bind(this),
                search: this.onSearchTeamLead.bind(this)
            });

            this.getView().addDependent(this._oSelectDialog);
        }

        this._oSelectDialog.open("");
    }

    private onSearchTeamLead(oEvent: any): void {
        const sQuery = oEvent.getParameter("value");
        const aFilters = [];

        if (sQuery && sQuery.length > 0) {
            aFilters.push(new Filter({
                filters: [
                    new Filter("firstName", FilterOperator.Contains, sQuery),
                    new Filter("lastName", FilterOperator.Contains, sQuery),
                    new Filter("email", FilterOperator.Contains, sQuery)
                ],
                and: false
            }));
        }

        const oBinding = this._oSelectDialog.getBinding("items");
        oBinding.filter(aFilters);
    }

    private async onTeamLeadSelected(oEvent: any): Promise<void> {
        const selectedItem = oEvent.getParameter("selectedItem");
        const teamModel = this.getView().getModel("team") as JSONModel;
        const teamData = teamModel.getData();
        const selectedUser = selectedItem.getBindingContext("dataModel").getObject();
        let response;

        if (selectedItem) {
            response = await this.getClient().models.TeamLead.create({
                userId: selectedUser.userId,
                teamId: teamData.id
            })
        }

        const newTeamLead = {
            id: response.data.id,
            userId: selectedUser.userId,
            user: {
                id: selectedUser.userId,
                firstName: selectedUser.firstName,
                lastName: selectedUser.lastName,
                email: selectedUser.email
            }
        };
        teamData.leads.push(newTeamLead);
        teamModel.setData(teamData);
    }

    private async onRemoveTeamLead(oEvent: Button$PressEvent): Promise<void> {
        const teamLead = oEvent.getSource().getBindingContext("team").getObject();
        const teamModel = this.getView().getModel("team") as JSONModel;
        const teamData = teamModel.getData();

        // Entfernen des gelöschten TeamLeads aus dem JSONModel "team"
        teamData.leads = teamData.leads.filter((lead: any) => lead.id !== teamLead.id);
        teamModel.setData(teamData);

        const { data, errors } = await this.getClient().models.TeamLead.delete({
            id: teamLead.id
        })
    }

}
